import './Box.css';
import Typography from '@mui/joy/Typography';

const Box = (props) => {
    const { title, backgroundColor, padding, style, children } = props;

    const containerStyles = {
        backgroundColor: backgroundColor || 'transparent',
        padding,
        ...style,
    };
    
    return (
        <div className="box" style={containerStyles}>
            {title && <Typography level="h2">{title}</Typography>}
            {children}
        </div>
    );
};

export default Box;